import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { UIElementType } from "../../../AppConstants";
import { FormSelect, FormTextField, FormRadioButton, FormCheckbox } from "../../index";
import { AppFormHeader, ButtonToolbar } from "../index";

const DynamicFormContainer = ({ header, onCancel, onSaveLabel, isWithAppForm = true, onSubmit = () => { } }) => {
  const { formMetaData, appformdata, reset, formState } = useFormContext();

  // Check if all required fields are filled
  // const isFormValid = watchFields.every(Boolean);

  useEffect(() => {
    const loadFormData = () => {
      reset(appformdata);
    };
    if (appformdata) {
      loadFormData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appformdata]);

  const renderElement = (fieldType, key) => {
    const fieldMetaData = fieldType.metadata;
    const fieldName = fieldType.name;
    const fieldId = `${fieldName}-${key}`;

    switch (fieldMetaData.elementType) {
      case UIElementType.TEXTFIELD:
        return (
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12} key={key}>
            <FormTextField
              name={fieldName}
              elementId={fieldId}
              isRequired={fieldMetaData?.isRequired}
              inputLabel={fieldMetaData?.inputLabel}
              inputType={fieldMetaData?.inputType}
              subtext={fieldMetaData?.subtext}
              isDisabled={fieldMetaData?.isDisabled}
            />
          </Grid>
        );
      case UIElementType.DROPDOWN:
        return (
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12} key={key}>
            <FormSelect
              name={fieldName}
              elementId={fieldId}
              isRequired={fieldMetaData?.isRequired}
              isMultiSelect={fieldMetaData?.isMultiSelect}
              inputLabel={fieldMetaData?.inputLabel}
              data={fieldMetaData?.options}
              isDisabled={fieldMetaData?.isDisabled}
              selectedField={fieldMetaData?.selectedValues}
            />
          </Grid>
        );
      case UIElementType.RADIOBUTTON:
        return (
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12} key={key}>
            <FormRadioButton
              name={fieldName}
              elementId={fieldId}
              isRequired={fieldMetaData?.isRequired}
              inputLabel={fieldMetaData?.inputLabel}
              isDisabled={fieldMetaData?.isDisabled}
            />
          </Grid>
        );
      case UIElementType.CHECKBOX:
        return (
          <Grid item xl={4} lg={4} md={6} xs={12} sm={12} key={key}>
            <FormCheckbox
              name={fieldName}
              elementId={fieldId}
              isRequired={fieldMetaData?.isRequired}
              inputLabel={fieldMetaData?.inputLabel}
              data={fieldMetaData?.data}
              isDisabled={fieldMetaData?.isDisabled}
              selectedField={fieldMetaData?.selectedValues}
            />
          </Grid>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <AppFormHeader header={header} />
      <Grid
        container
        rowSpacing={4}
        columnSpacing={{ xs: 2, md: 3, xl: 8, lg: 10 }}
        sx={{
          paddingLeft: {
            xl: "20px",
            lg: "20px",
          },
          paddingRight: {
            xl: "20px",
            lg: "20px",
          },
          paddingBottom: {
            xl: "20px",
            lg: "20px",
          },
        }}
      >
        {formMetaData &&
          formMetaData.map((item, index) => {
            return renderElement(item, index);
          })}
      </Grid>
      <ButtonToolbar
        onCancel={onCancel}
        isFormValid={formState.isValid}
        isFormDirty={formState.isDirty}
        onSaveLabel={onSaveLabel}
        isWithAppForm={isWithAppForm}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default DynamicFormContainer;
